<div class="layout">

  <!-- ── Top Bar ── -->
  <header class="topbar">
    <div class="topbar__brand">
      <span class="topbar__logo">⚡</span>
      <span class="topbar__title">Monou Chat</span>
    </div>

    <!-- Connection form (always visible at the top) -->
    <form class="topbar__form" (ngSubmit)="conectar()" *ngIf="!conectado">
      <div class="field">
        <label class="field__label" for="idTorneo">ID Torneo</label>
        <input
          id="idTorneo"
          class="field__input"
          type="number"
          [(ngModel)]="idTorneo"
          name="idTorneo"
          placeholder="Ej: 2286"
          min="1"
          [disabled]="cargando"
          required
        />
      </div>

      <div class="field">
        <label class="field__label" for="idUsuario">ID Usuario</label>
        <input
          id="idUsuario"
          class="field__input"
          type="number"
          [(ngModel)]="idUsuario"
          name="idUsuario"
          placeholder="Ej: 1001"
          min="1"
          [disabled]="cargando"
          required
        />
      </div>

      <button
        class="btn btn--primary"
        type="submit"
        [disabled]="cargando || !idTorneo || !idUsuario"
      >
        {{ cargando ? 'Conectando…' : 'Conectar' }}
      </button>

      <span class="topbar__error" *ngIf="errorMsg">{{ errorMsg }}</span>
    </form>

    <!-- Connected state: session info + disconnect button -->
    <div class="topbar__session" *ngIf="conectado">
      <div class="session-info">
        <span class="session-chip">
          <span class="chip__label">Torneo</span>
          <span class="chip__value">#{{ tournamentForChat?.id }}</span>
        </span>
        <span class="session-chip">
          <span class="chip__label">Usuario</span>
          <span class="chip__value">#{{ usuarioActual?.id }}</span>
        </span>
        <span class="session-chip session-chip--nick">
          <span class="chip__value">{{ usuarioActual?.username }}</span>
        </span>
      </div>
      <span class="ws-status" [ngClass]="getEstadoClass()">
        <span class="ws-status__dot"></span>
        {{ getEstadoLabel() }}
      </span>
      <button class="btn btn--ghost" (click)="desconectar()">Desconectar</button>
    </div>
  </header>

  <!-- ── Main Content ── -->
  <main class="main">
    <!-- Landing panel when not connected -->
    <div class="landing" *ngIf="!conectado">
      <div class="landing__card">
        <div class="landing__icon">💬</div>
        <h2 class="landing__title">Chat de torneos en tiempo real</h2>
        <p class="landing__desc">
          Ingresa el <strong>ID del torneo</strong> y tu <strong>ID de usuario</strong>
          en la barra superior para unirte al chat.
        </p>
        <ul class="landing__features">
          <li>🏠 Sala general del torneo</li>
          <li>⚔️ Salas de partidas en vivo</li>
          <li>👥 Salas de equipo</li>
          <li>📋 Comandos: /ayuda, /resultados, /reportar…</li>
        </ul>
        <div class="landing__hint">
          El token se genera automáticamente — no hace falta configurarlo.
        </div>
      </div>
    </div>

    <!-- Chat area when connected -->
    <div class="chat-area" *ngIf="conectado">
      <monou-chat
        [tournament]="tournamentForChat"
        [currentUser]="usuarioActual"
        [token]="tokenGenerado"
        [config]="chatConfig"
        [commands]="chatCommands"
        [isAdmin]="esAdmin"
        [welcomeMessage]="welcomeMessage"
        height="calc(100vh - 64px)"
        width="100%"
      ></monou-chat>
    </div>
  </main>

</div>
